import { NavigationBar } from "@/components/Complex/NavigationBar"
import { useLocation } from "react-router-dom"

export function SmartNavigation() {
  const location = useLocation()
  const pathname = location.pathname
  const shouldHideNavigation =
    pathname?.startsWith("/signup") || pathname?.startsWith("/login")

  if (shouldHideNavigation) {
    return null
  }

  return <NavigationBar />
}
